import { render, staticRenderFns } from "./CheckboxTopics.vue?vue&type=template&id=521e4bfd&scoped=true&"
import script from "./CheckboxTopics.vue?vue&type=script&lang=js&"
export * from "./CheckboxTopics.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxTopics.vue?vue&type=style&index=0&id=521e4bfd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e4bfd",
  null
  
)

export default component.exports